import { getLocale } from "../runtime";

const sv_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `T.ex. 'ekologisk makeup'`
};

const searchbarplaceholder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchbarplaceholder(inputs)
	return "searchBarPlaceholder";
};

export { searchbarplaceholder as "searchBarPlaceholder" };